import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Card, CardHeader, CardBody } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import placeholderImage from '../../../../assets/images/placeholder.jpg';

const RecentFeedback = React.memo(({ feedback }) => {
  return (
    <Col xl={4} lg={4} md={4} sm={12}>
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center bg-white">
          <h6 className="card-title mt-2">Recent Feedback</h6>
          {Array.isArray(feedback) && feedback.length > 4 && (
            <div className="text-center">
              <button
                className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-btn-viewall"
                onClick={() =>
                  (window.location.href = `${window.location.origin}/communication?tab=tab2`)
                }
              >
                View All
              </button>
            </div>
          )}
        </CardHeader>
        <CardBody className="p-0">
          <SimpleBar className="p-3">
            <ul className="list-unstyled chat-list mb-0">
              {Array.isArray(feedback) && feedback.length > 0 ? (
                feedback.map((chat) => (
                  <li
                    key={chat?.id ?? Math.random()}
                    className="active py-2 border-bottom"
                  >
                    <Link
                      to={`/communication/feedbacks/${chat?.id}`}
                      className="text-decoration-none"
                    >
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0 user-img align-self-center me-4">
                          <img
                            src={placeholderImage || '/default-avatar.png'}
                            alt="User"
                            className="rounded-circle border"
                            style={{
                              height: '40px',
                              width: '40px',
                              marginLeft: '5px',
                            }}
                          />
                        </div>

                        <div
                          className="flex-grow-1 overflow-hidden"
                          style={{ maxWidth: '400px' }}
                        >
                          <h5 className="text-truncate font-size-14 mb-1 adjust-fs">
                            {chat?.name || 'Unknown User'}
                          </h5>
                          <p className="text-truncate mb-0 text-muted adjust-fs">
                            {chat?.description || 'No description available'}
                          </p>
                        </div>
                        <div
                          className="fs-10 text-muted"
                          style={{
                            fontSize: '11px',
                            marginLeft: 'auto',
                            marginRight: '10px',
                            paddingLeft: '8px',
                          }}
                        >
                          {chat?.createdAt || 'N/A'}
                        </div>
                      </div>
                    </Link>
                  </li>
                ))
              ) : (
                <h6 className="text-center py-3 text-muted">
                  No feedback available
                </h6>
              )}
            </ul>
          </SimpleBar>
        </CardBody>
      </Card>
    </Col>
  );
});

export default RecentFeedback;
